export class CaseManSearchRequest{
    centerId:string;
    searchCriteria:string;
    constructor(centerId:string,searchCriteria:string){
        this.centerId=centerId;
        this.searchCriteria=searchCriteria;
    }
}